import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../config";
import { getSession } from "utils/jwt";

export const baseQuery = (withHeader: boolean | undefined = true) =>
  fetchBaseQuery({
    baseUrl: BASE_URL,
    jsonContentType: "application/json",
    ...((withHeader as boolean) && {
      prepareHeaders: (headers) => {
        const token = getSession();
        if (token) headers.set("lt", token);
        headers.set("ln", "fa");
        return headers;
      },
    }),
  });
